import { UserProfile } from "@/api/types"

export const defaultUserProfile: UserProfile = {
  idUser: 1,
  customID: '',
  email: 'email@example.org',
  birthDate: '1960-01-12T00:00:00.000Z',
  gender: 'M',
  expertiseLevel: 'INTERMEDIATE',
  weightLogs: [
    {
      weightKg: 71.2,
    },
  ],
  heightLogs: [
    {
      heightCm: 176,
    },
  ],
  activityLevels: [
    {
      value: 'LOWEST',
    },
  ],
  household: {
    idHousehold: -1,
    noOfMealsPerDay: 6,
    selectedMeals: [
      { mealOfDay: 'BREAKFAST' },
      { mealOfDay: 'LUNCH' },
      { mealOfDay: 'DINNER' },
      { mealOfDay: 'AFTER_DINNER' },
    ],
  },
  mealOfDayDivisions: [
    {
      idMealOfDayDivision: 1,
      mealOfDay: 'BREAKFAST',
      type: 'MEAL_PART',
      mealPart: 'BREAKFAST',
    },
    {
      idMealOfDayDivision: 4,
      mealOfDay: 'MIDDLE_MORNING',
      type: 'MEAL_PART',
      mealPart: 'SNACK',
    },
    {
      idMealOfDayDivision: 5,
      mealOfDay: 'LUNCH',
      type: 'MEAL_PART',
      mealPart: 'SOUP',
    },
    {
      idMealOfDayDivision: 6,
      mealOfDay: 'LUNCH',
      type: 'MEAL_PART',
      mealPart: 'LUNCH',
    },
    {
      idMealOfDayDivision: 8,
      mealOfDay: 'MIDDLE_AFTERNOON',
      type: 'MEAL_PART',
      mealPart: 'SNACK',
    },
    {
      idMealOfDayDivision: 10,
      mealOfDay: 'DINNER',
      type: 'MEAL_PART',
      mealPart: 'DINNER',
    },
    {
      idMealOfDayDivision: 11,
      mealOfDay: 'AFTER_DINNER',
      type: 'MEAL_PART',
      mealPart: 'SNACK',
    },
  ],
  dietaryRestrictions: [],
  foodRestrictions: [],
  userIngredientFeedbacks: [],
  notes: 'some notes',
}
